import React from "react";
import { Link } from "react-router-dom";

function Card({ item }) {
  return (
    <Link
   
      to={`/categories/${item?.slug || item?.slugPath}`}
      className="ith-cat-mini-card"
    >
      {/* <div className="category-card square-card"> */}
        <div className="ith-cat-mini-img-box">
          {item?.image && (
            <img
              src={item?.image}
              alt={item?.name}
              className="ith-cat-img-cover"
            />
          )}
          {/* <div className="category-overlay"></div> */}
        </div>

       <h6 className="ith-cat-mini-name">{item?.name}</h6>
        {/* <div className="category-title-box text-start">
          <h3 className="category-title">{item?.name}</h3>
          <span className="shop-now-text">Explore</span>
        </div> */}
      {/* </div> */}
    </Link>
  );
}

export default Card;